import { render, staticRenderFns } from "./PresentationKebabMenu.vue?vue&type=template&id=dcd23a9c&scoped=true&"
import script from "./PresentationKebabMenu.vue?vue&type=script&lang=js&"
export * from "./PresentationKebabMenu.vue?vue&type=script&lang=js&"
import style0 from "./PresentationKebabMenu.vue?vue&type=style&index=0&id=dcd23a9c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd23a9c",
  null
  
)

export default component.exports